<template>
  <div>
    <NBar title="奖励设置" :top="true"/>
    <div class="spread-content">
      <nut-row v-for="(item,index) in spreadAward" :key="index" :style="index > 0 ? 'margin-top: 15px' : ''">
        <nut-col :span="24">
          <nut-cell :show-icon="false">
            <span slot="title">级别：{{item.levelName}}</span>
          </nut-cell>
        </nut-col>
        <nut-col :span="12">
          <div class="item">
            <nut-textinput v-model="item.ewmNum" label="扫码次数：" placeholder="请输入次数"
                           :has-border="true" :clearBtn="false" :disabled="false" class="input"/>
          </div>
        </nut-col>
        <nut-col :span="12">
          <div class="item">
            <nut-textinput v-model="item.num" label="奖励次数：" placeholder="请输入奖励次数"
                           :has-border="true" :clearBtn="false" :disabled="false" class="input"/>
          </div>
        </nut-col>
        <nut-col :span="24">
          <div class="item">
            <nut-textinput v-model="item.money" label="奖励金额：" placeholder="请输入奖励金额"
                           :has-border="true" :clearBtn="false" :disabled="false" class="input"/>
          </div>
        </nut-col>
        <nut-row v-for="(sub,subIndex) in item.spread" :key="subIndex" class="spread-row">
          <nut-col :span="24">
            <nut-cell :show-icon="false">
              <span slot="title">级别：{{sub.levelName}}</span>
            </nut-cell>
          </nut-col>
          <nut-col :span="12">
            <div class="item">
              <nut-textinput v-model="sub.award" label="奖励：" placeholder="请输入奖励"
                             :has-border="true" :clearBtn="false" :disabled="false" class="input"/>
              <span style="font-size: 14px;margin-left: 5px">{{sub.size == 0 ? '之前' : '之后'}}</span>
            </div>
          </nut-col>
          <nut-col :span="12">
            <div class="item">
              <nut-textinput v-model="sub.money" label="奖励金额：" placeholder="请输入奖励金额"
                             :has-border="true" :clearBtn="false" :disabled="false" class="input"/>
              <span style="margin-left: 5px">%</span>
            </div>
          </nut-col>
        </nut-row>
      </nut-row>
    </div>
    <div class="bottom">
      <nut-button block class="save-btn" @click="save">保存</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardSet',
  props: ['data'],
  data () {
    return {
      form: {
        id: null,
        spreadAward: '',
      },
      spreadAward: [{
        levelId: null,
        ewmNum: null,
        money: 0,
        num: 0,
        spread: [{
          size: 0,
          award: null,
          levelId: null,
          money: 0,
        }]
      }],
      showLevel: false,
      isLevelLoading: false,
      levelList: [],
      type: null,
      index: null,
      subIndex: null
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData: function () {
      this.$api.post({
        url: '/device/api/device/device-config/find'
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.$util.ofData(this.form, res.data)
          if (!this.$util.isArrOrNull(res.data.spreadAward)) {
            this.spreadAward = JSON.parse(res.data.spreadAward)
          }
        }
      })
    },
    save () {
      this.form.spreadAward = JSON.stringify(this.spreadAward)
      this.$api.post({
        url: '/device/api/device/device-config/save',
        data: this.form,
      }).then(() => {
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      })
    },
    serviceDownClick () {
      this.isLevelLoading = true
    },
  }
}
</script>

<style scoped>
  .spread-content {
    margin-bottom: 100px;
  }

  .item {
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .spread-row {
    margin: 0 10px;
    background-color: #fff;
  }

  /* 底部 */
  .bottom {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 15px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    background-color: #ffffff;
  }

  .bottom .save-btn {
    margin: 0 15px;
    border-radius: 5px;
    width: 92%;
  }


  >>> .nut-button {
    background: #409EFF;
  }

  >>> .nut-radio input:checked {
    background-color: #007aff;
    border-color: #007aff;
  }

  >>> .nut-radio input:after {
    background: #007aff;
  }

  >>> .nut-textinput input {
    width: 85px;
  }

  >>> .nut-checkbox input:after {
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/SpreadSet.vue